import React from 'react';
import { useSelector } from 'react-redux';

import SubmitFormDialog from './SubmitFormDialog';

const withSubmitFormDialog = (Component) => (props) => {
  const formIsSubmitting = useSelector((state) => state.workflow.formIsSubmitting);
  const finishSubmit = useSelector((state) => state.workflow.finishSubmit);
  const noErrors = useSelector((state) => !state.errors.length);

  return (
    <>
      <Component {...props} />
      {(formIsSubmitting || finishSubmit) && noErrors && <SubmitFormDialog open />}
    </>
  );
};

export default withSubmitFormDialog;
